import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';

import useStyles from './FormValidationMessage.styles';

interface FormValidationMessageProps {
  title: string;
  children: React.ReactNode | React.ReactNode[];
}

/**
 * Компонент для отображения сообщения валидации формы.
 * @param {string} title - Заголовок сообщения.
 * @param {React.ReactNode | React.ReactNode[]} children - Дочерние элементы компонента.
 * @returns {React.ReactElement} Возвращает элемент с сообщением валидации формы.
 */

export const FormValidationMessage = ({
  title,
  children,
}: FormValidationMessageProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.message}>
      <Box
        display="flex"
        flexDirection="column"
        p="16"
        bgcolor="bg.greyscale.primary"
        radius="l"
      >
        <Box mb="4">{title}</Box>
        {children}
      </Box>
    </div>
  );
};
